// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const UpdatedSelectDynamicWrapper = styled.div`
  display: grid;
  grid-column-gap: .15em;
  grid-row-gap: .15em;
  grid-template-areas:
    "label label"
    "select lookup"
    "error error";
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 2em 1fr;

  > .label {
    grid-area: label;
  }

  > .select {
    grid-area: select;

    height: auto;
    width: 100%;
  }

  > .lookup {
    grid-area: lookup;

    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 2em;
  }

  > .error-message {
    grid-area: error;
  }
`
